/*
 * Sticky add-to-cart bar (mobile PDP).
 *
 * The bar's button submits the real product form via its form= attribute,
 * so variant selection, the cart drawer, and product-form.js's own submit
 * handling all work unchanged — no duplicated add-to-cart logic.
 *
 * The bar appears only while the real buy buttons are scrolled out of view,
 * and mirrors the main submit button's label and disabled state (sold out,
 * unavailable) plus the live price, all driven by observers rather than by
 * re-implementing variant logic.
 */
(() => {
  function init(bar) {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';

    const sectionId = bar.dataset.sectionId;
    const mainSubmit = document.getElementById(`ProductSubmitButton-${sectionId}`);
    const mainPrice = document.getElementById(`price-${sectionId}`);
    const barSubmit = bar.querySelector('[data-sticky-atc-submit]');
    const barLabel = bar.querySelector('[data-sticky-atc-label]');
    const barPrice = bar.querySelector('[data-sticky-atc-price]');

    if (!mainSubmit || !barSubmit) return;

    // Show the bar only while the real buy buttons are out of view.
    const observer = new IntersectionObserver(
      ([entry]) => {
        bar.classList.toggle('sticky-atc--visible', !entry.isIntersecting);
      },
      { rootMargin: '-80px 0px 0px 0px' }
    );
    observer.observe(mainSubmit);

    // Mirror label + disabled state from the real button (sold out etc.).
    const mirrorButton = () => {
      const span = mainSubmit.querySelector('span');
      if (span && barLabel) barLabel.textContent = span.textContent.trim();
      const disabled = mainSubmit.hasAttribute('disabled') || mainSubmit.getAttribute('aria-disabled') === 'true';
      barSubmit.toggleAttribute('disabled', disabled);
    };

    // Mirror the price block so variant changes stay in sync.
    const mirrorPrice = () => {
      if (!mainPrice || !barPrice) return;
      const price = mainPrice.querySelector('.price__regular, .price__sale');
      if (price) barPrice.innerHTML = price.innerHTML;
    };

    mirrorButton();
    mirrorPrice();

    new MutationObserver(mirrorButton).observe(mainSubmit, {
      attributes: true,
      childList: true,
      subtree: true,
    });
    if (mainPrice) {
      new MutationObserver(mirrorPrice).observe(mainPrice, { childList: true, subtree: true });
    }
  }

  function initAll(root = document) {
    root.querySelectorAll('[data-sticky-atc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
